import React from 'react'
import moment from 'moment/moment'
import { Link } from 'react-router-dom'

function EmbroideryErrorInBatchRow(props) {
    const { item, setType, setBrand } = props
    const { batch, embroidery_error, product_type } = item
    const { partner } = { ...batch}

    const barcode_number = item.item.marketplace
    const item_number = item.item.item_number
    const brand = item.item.brand
    const barcodeNumber = barcode_number + '_' + item_number

    const onClickType = (value) => {
        setType(value)
    }
    const onClickBrand = (value) => {
        setBrand(value)
    }
    const _mapStatus = (status) => {
        if (!status) {
            return null
        }

        let output = ''
        switch (status) {
            case 'error':
            case 'archived':
                output = <span className="badge badge-danger badge-pill">{status}</span>
                break
            case 'embroidered':
            case 'fully-done':
            case 'done':
            case 'printed':
            case 'completed':
                output = <span className="badge badge-success badge-pill">{status}</span>
                break
            case 'pending':
            case 'retry':
            case 'waiting':
                output = <span
                    className="badge badge-info badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'processing':
                output = <span
                    className="badge badge-primary badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'on-hold':
            case 'unprinted':
            case 'pushed':
            case 'disabled':
                output = <span className="badge badge-secondary badge-pill">{status}</span>
                break
            case 'review':
                output = <span
                    className="badge badge-warning badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'cancelled':
                output = <span className="badge badge-dark badge-pill">{status}</span>
                break
            case 'free':
                output = <span
                    className="badge badge-primary badge-pill">{status}</span>
                break
            case 'printing':
                output = <span
                    className="badge printing badge-pill">{status}</span>
                break
            case 'transferring':
                output = <span
                    className="badge transferring badge-pill">{status}</span>
                break
            case 'transferred':
                output = <span
                    className="badge transferred badge-pill">{status}</span>
                break
            case 'confirmed':
                output = <span
                    className="badge confirmed badge-pill">{status}</span>
                break
            case 'wait_to_sew':
                output = <span
                    className="badge wait-sew badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'sewing':
                output = <span
                    className="badge sewing badge-pill">{status}</span>
                break
            case 'cancel-ship':
                output = <span
                    className="badge cancel-ship badge-pill">{status}</span>
                break
            case 'moved':
                output = <span
                    className="badge moved badge-pill">{status}</span>
                break
            default:
                output = status
        }

        return output
    }

    return (
        <tr>
            <td className='Barcode'>
                {!!barcode_number &&
                    <Link
                        to={`/order-item?template=${barcodeNumber}`}
                        target='_blank'>
                        #{barcodeNumber}
                    </Link>
                }
            </td>
            <td className='ProductType'>
                {!!product_type &&
                    <span className="mr-2" onClick={() => onClickType([product_type])}>{product_type}</span>
                }
                {!!brand && !!brand.name &&
                    <div className='Brand'>
                        <span className="mr-2" onClick={() => onClickBrand([brand.name])}>{brand.name}</span>
                    </div>
                }
            </td>
            <td className='Status'>{_mapStatus(item.status)}</td>
            <td className='BatchName'>
                {/* {item.batch ?
                    <Link to={`/batches/${item.batch._id}`}>{item.batch.name || ''}</Link> : ''
                } */}
                {item.batch.name || ''}
            </td>
            <td className='Size'>{item.item.size || '-'}</td>
            <td className='CreatedDate'>{moment(embroidery_error.pending_at).format('HH:mm DD/MM/YYYY') || '-'}</td>
            <td className='ErrorType'>{!!embroidery_error && !!embroidery_error.type ? embroidery_error.type : '-'}</td>
            <td className='Partner'>{!!partner && !!partner.name ? partner.name : '-'}</td>
        </tr>
    )
}

export default EmbroideryErrorInBatchRow